package structs.promo

import kotlinx.serialization.Serializable

/**
 * Operator-side promo-code inventory, persisted as a single cloud-save
 * admin game record under key `promo-codes` in the namespace
 * `echoofmaridia-autogenesis`.
 *
 * The KVision admin console writes this document via
 * `AdminPostGameRecordHandlerV1`. The player-side redemption path
 * (`PromoCodeRegistryStorage`) reads it on every code lookup and
 * mutates the matched row's `status` field on successful redemption.
 *
 * One document = the operator's complete promo inventory. Single-write
 * consistency beats per-row atomicity for an inventory this small
 * (typical size: dozens to low hundreds of codes). Mutations are
 * read-modify-write with a `ReentrantLock` in the storage layer.
 *
 * Schema-versioned via [version]. Bump when the on-disk shape changes
 * incompatibly; the storage layer rejects documents on older versions.
 *
 * @property version Schema version, monotonically increasing. Set to 1
 *   on first write; never decrement.
 * @property codes Operator-defined code rows plus their redemption
 *   state.
 */
@Serializable
data class PromoCodeRegistry(
    val version: Int = 1,
    val codes: List<PromoCodeRegistryEntry> = emptyList(),
)
